import React, { Suspense, lazy } from "react";
import { Loading } from "@Core/Components/Loader";

const TrackGuestRequestServiceView = lazy(() =>
  import(/* webpackChunkName: "track-guest-request" */ "./view")
);

const TrackGuestRequestServiceWrapper = (props) => {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <TrackGuestRequestServiceView {...props} />
      </Suspense>
    </>
  );
};

export default TrackGuestRequestServiceWrapper;
